const APP_ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  TOKEN_PAGE: "/token/:token",
  FLIGHT_LIST: "/flight",
  TEST_ANALYSIS_LIST: "/wind-tunnel-test-isas",
  WIND_TUNNEL_TEST_NAL: "/wind-tunnel-test-nal",
  FLIGHT_NEW: "/flight/new",
  ROCKET_MODEL: "/rocket-model",
  AERODYNAMICS: "/aerodynamics",
  ROCKET_MODEL_DETAIL: "/rocket-model/:id",
  LITERATURE_VALUES: "/literature-values",
  CFD_RESULTS: "/cfd-results",
  THRUST_CALCULATION_LIST: "/thrust-calculator",
  ENGINE_COMPONENT_LIST: "/engine-component",
  FLIGHT_DUPLICATE_DETAIL: "/flight/:id",
  GNC_SIMULATOR: "/gnc-simulator",
  GNC_SIMULATOR_DETAIL: "/gnc-simulator/:id",
  GNC_SIMULATOR_NEW: "/gnc-simulator/new",
  GNC_SIMULATOR_NEW_6DOF: "/gnc-simulator-6dof/new",
  ACCESS_DENIED: "/access-denied",
  NOT_FOUND: "/404",
  GNC_SIMULATOR_6DOF: "/gnc-simulator-6dof",
  GNC_SIMULATOR_6DOF_NEW: "/gnc-simulator-6dof/new",
  GNC_SIMULATOR_6DOF_DETAIL: "/gnc-simulator-6dof/:id",
};

export default APP_ROUTES;
